import React, { FC } from "react";
import { TabelHeading } from "../../../../models/tabelHeading";

export interface TabelHeadingProps {
  heading: TabelHeading;
  elementId: String;
  sectionId: String;
  formId: String;
  tableTheam: String;
}

const TableHeading: FC<TabelHeadingProps> = ({
  heading,
  elementId,
  sectionId,
  formId,
  tableTheam,
}) => {
  return <th scope="col" style={{
     borderBottom: tableTheam === "table-borderless" || tableTheam === undefined || tableTheam === "" ? '0px' : '', borderTop: tableTheam === "table-borderless" || tableTheam === undefined || tableTheam === "" ? '0px' : '',
  }}>{heading.name}</th>;
};

export default TableHeading;
